import {Button} from '@wandb/components';
import {useWindowSize} from '@wandb/weave/common/hooks/useWindowSize';
import React from 'react';

import {trackAddPanels} from '../../../services/analytics/addPanelsEvents';
import {type Ref as PanelBankSectionConfigRef} from '../../../state/views/panelBankSectionConfig/types';
import {useWorkspaceDrawerContext} from '../../WorkspaceDrawer/WorkspaceDrawerContextProvider';

type AddPanelsDrawerButtonProps = {
  targetSectionRef?: PanelBankSectionConfigRef;
};

export const AddPanelsDrawerButton = ({
  targetSectionRef,
}: AddPanelsDrawerButtonProps) => {
  const {responsiveSize} = useWindowSize();
  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  if (responsiveSize === 'small') {
    return null;
  }

  const scope = targetSectionRef ? 'section' : 'global';

  return (
    <Button
      data-test={`add-vis-${scope}`}
      variant={targetSectionRef ? 'ghost' : 'primary'}
      startIcon="add-new"
      onPress={() => {
        openWorkspaceDrawer('add-panels', targetSectionRef);
        trackAddPanels({
          action: 'Drawer opened',
          scope,
        });
      }}>
      Add panels
    </Button>
  );
};
